import { EmblaCarouselType } from 'embla-carousel';

function generateBulletsButtons(
  embla: EmblaCarouselType,
  bulletsContainer: HTMLElement,
  onClick?: () => void
) {
  const bullets = embla.scrollSnapList().map((slide, index) => {
    const button = document.createElement('button');
    button.classList.add('carousel-bullet-item');
    if (slide === 0) button.classList.add('active');
    button.addEventListener('click', () => {
      embla.scrollTo(index);
      if (onClick && !button.classList.contains('active')) {
        onClick();
      }
    });
    return button;
  });

  bullets.forEach((bullet) =>
    bulletsContainer.insertAdjacentElement('beforeend', bullet)
  );

  const rendered = bulletsContainer.querySelectorAll(
    'button'
  ) as NodeListOf<HTMLButtonElement>;

  embla.on('select', () => {
    bulletsContainer.querySelector('.active')?.classList.remove('active');
    const selected = Math.ceil(embla.selectedScrollSnap());
    rendered[selected].classList.add('active');
  });
}

export default generateBulletsButtons;
